export default {
  userInfo: state => state.userInfo || {},
  permissions: state => state.permissions || [],
  isOwner: state => state.userInfo.data_type === '1',
  isDaquer: state => state.userInfo.data_type === '2',
  isXiaoquer: state => state.userInfo.data_type === '3',
  isDealer: state => state.userInfo.data_type === '4',
  getBusinessNameById: state => id => id && state.businessTypes[id],
  getChildTaskTypeNameById: state => id => id && state.childTaskTypes[id],
  getAbnormalNameById: state => id => id && state.abnormalTypes[id],
  checkAuth: (state, getters) => {
    const { check_permission: check = '' } = getters.userInfo
    return {
      one: check.includes(1),
      two: check.includes(2),
      zhong: check.includes(3)
    }
  }
}
